module.exports = __webpack_public_path__ + "img/arrow_left.3e6ce086.svg";